var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-dialog',_vm._b({attrs:{"value":_vm.value},on:{"input":_vm.update,"click:outside":_vm.clickOutside},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_vm._t("activator",null,null,attrs)]}}],null,true)},'v-dialog',_vm.$props,false),[_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }